import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { Spiner } from "../../components/spinner/Spiner";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { convertDateToJapaneseString } from "../../utility/ConvertUtily";
import { auth } from "../../firebase";
import companiesQuery from "../../firestore/Companies.query";
import { Company } from "../../model/Companies";
import pointDataQuery from "../../firestore/PointData.query";
import { PointHistoryData } from "../../model/PointData";
import messagesQuery from "../../firestore/Messages.query";

export const PointHistoryInfo = () => {
  // ポイント履歴ID
  const { pointHistoryId } = useParams<{ pointHistoryId: string }>();
  // 戻る画面の選択
  const { returnDisply } = useParams<{ returnDisply: string }>();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = auth.currentUser;

  const [isLoad, setIsLoad] = useState(true);
  const [pointHistory, setPointHistory] = useState<PointHistoryData>();
  const [company, setCompany] = useState<Company>();
  const [messageTitle, setMessageTitle]  = useState<string>();

  const now = new Date();
  const nowDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  )

  const styles = {
    header: "text-right mr-8 text-sm text-gray-500 whitespace-nowrap",
    body:"text-left text-sm",
    margin:"flex ml-6 mb-3",
  };

  useEffect(() => {
    const f = async () => {
      try {
        // 団体情報
        const company = await companiesQuery.getCompany(currentUser?.tenantId!);
        setCompany(company);
        //ポイント履歴のデータを取得
        if(pointHistoryId != undefined){
          const pointHistoryData = await pointDataQuery.getPointHistoryData(currentUser?.tenantId!,pointHistoryId) as PointHistoryData;
          setPointHistory(pointHistoryData)
          if(pointHistoryData.eventMsgId != undefined){
            // お知らせ取得
            const message = await messagesQuery.getMessage(pointHistoryData.eventMsgId);
            setMessageTitle(message.title);
          }
        }
      } catch (error) {
        console.error(error);
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
      setIsLoad(false);
    };
    f();
  },[]);

  return(
    <div className="flex h-full">
      <div className="relative z-0 flex flex-1">
        <main className="relative z-0 flex-1 focus:outline-none xl:order-last">
          <nav
            className="flex items-start px-4 py-3"
            aria-label="Breadcrumb"
          >
            <div className="inline-flex items-center space-x-3 text-sm font-medium text-gray-900 cursor-pointer">
              
              <span onClick={() => navigate(returnDisply === "point" ? "/pointHistoryList" : `/userList/${company?.displayId}${returnDisply}/info`)}  className="flex items-center">
                <ChevronLeftIcon className="-ml-2 h-5 w-5 text-gray-400 mr-3" />
                一覧へ
              </span>
            </div>
          </nav>
          {isLoad ? <Spiner/> : (
            <>
              <div className="m-6">
                <div className="max-w-5xl px-3 px-6 px-8">
                  <h2 className="text-xl font-semibold text-gray-900">
                  ポイント履歴詳細
                  </h2>
                </div>
                <div className="bg-indigo-50 mt-5 ml-8 py-8 min-w-[500px]">
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　利用者番号</div>
                    <div className={`${styles.body}`}>{pointHistory?.displayUserId}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　　　　名前</div>
                    <div className={`${styles.body}`}>{pointHistory?.userName}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　　カテゴリ</div>
                    <div className={`${styles.body}`}>{pointHistory?.ptCategoryName}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　　　タイプ</div>
                    <div className={`${styles.body}`}>{pointHistory?.ptTypeName}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　ポイント名</div>
                    <div className={`${styles.body}`}>{pointHistory?.ptName}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　　有効期限</div>
                    <div className={`${styles.body}`}>{pointHistory?.expirationDate ? convertDateToJapaneseString(new Date(pointHistory.expirationDate)) : ""}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　ポイント発生日</div>
                    <div className={`${styles.body}`}>{pointHistory?.occurrenceDate ? convertDateToJapaneseString(new Date(pointHistory.occurrenceDate)) : ""}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　　取引種別</div>
                    <div className={`${styles.body}`}>{pointHistory?.tranType}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　　　ポイント数</div>
                    <div className={`${styles.body}`}>{pointHistory?.grantPoints}</div>
                  </div>
                  <div className={`${styles.margin}`}>
                    <div className={`${styles.header}`}>　保有ポイント数</div>
                    <div className={`${styles.body}`}>{pointHistory?.heldPoints !== undefined ? pointHistory?.heldPoints : "ポイント発生日前"}</div>
                  </div>
                  {pointHistory?.eventMsgId && pointHistory?.eventMsgId !== "" ? (
                    <>
                      <div className={`${styles.margin}`}>
                        <div className={`${styles.header}`}>　　イベント詳細</div>
                        <a 
                          key={pointHistory.eventMsgId}
                          href={`/message/${pointHistory.eventMsgId}/info`}
                          className={"underline text-indigo-500"}
                        >
                          {messageTitle}
                        </a>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {pointHistory?.tranType === "調整"? (
                    <>
                      <div className={`${styles.margin}`}>
                        <div className={`${styles.header}`}>　　　　　　備考</div>
                        <div className={`${styles.body} whitespace-pre-wrap`}>{pointHistory.note}</div>
                      </div>
                    </>
                    ) : (
                    <></>
                  )}
                </div>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
}